<template>
  <h4 class="text-xl font-bold">{{ t('Select SpO2 and FiO2') }}</h4>
  <div class="md:grid md:grid-cols-2 md:gap-7">
    <div class="bg-white rounded mt-3 mb-6 px-6 py-3 text-base md:mb-6 md:grid md:grid-rows-1">
      <input-range
        name="spo2"
        title="sa_saturation"
        :minValue="0"
        :maxValue="100"
        :changeValue="spo02Topao2Values.spo2"
        @on-change-input-range-value="handleChangeSpo02Topao2Values"
      />
    </div>
    <div class="bg-white rounded mt-3 mb-9 px-6 py-3 text-base md:mb-6 md:grid md:grid-rows-1">
      <input-range
        name="fio2"
        title="sa_fraction"
        :minValue="1"
        :maxValue="100"
        :changeValue="spo02Topao2Values.fio2"
        @on-change-input-range-value="handleChangeSpo02Topao2Values"
      />
    </div>
  </div>
  <div class="flex flex-col">
    <div class="flex">
      <div class="flex items-center max-w-[1rem]">
        <img src="@/assets/infoShape.svg" alt="item info" class="block h-4 p-0 m-0" />
      </div>
      <p class="text-sm font-medium leading-6 pl-2">
        {{ $t('The non-linear equation utilized by this calculator is deriven in') }}
        <a
          :href="sp2Links.BrownEtAlChestLink"
          target="_blank"
          class="text-sm font-medium leading-6 pl-1 text-yellow underline cursor pointer"
        >
          Brown et al Chest 2016
        </a>
      </p>
    </div>
    <div v-if="isBreakpointSmallerOrEqualToSM" class="mb-6 order-first">
      <collapse-mobile text="Non-linear equation">
        <img src="@/assets/brown_etal_nonlinear_equation.png" alt="Brown non-linear equation" />
      </collapse-mobile>
    </div>
    <img
      v-else
      src="@/assets/brown_etal_nonlinear_equation.png"
      alt="Brown non-linear equation"
      class="my-6 mb-6 py-1"
    />
  </div>
</template>

<script setup>
import { defineEmits, reactive } from 'vue';

import CollapseMobile from '@/common/components/CollapseMobile.vue';
import InputRange from '@/common/components/InputRange.vue';
import { isBreakpointSmallerOrEqualToSM } from '@/common/utils';
import {
  calculateImputedPaO2,
  calculatePfratio,
  calculateSfratio,
} from '@/modules/Oxygen/services/sp2.service';
import { sp2Links } from '@/modules/Oxygen/utils';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emits = defineEmits(['imputedPaO2', 'pfRatio', 'sfRatio']);

const spo02Topao2Values = reactive({
  spo2: 90,
  fio2: 21,
});

const handleChangeSpo02Topao2Values = ({ value, name }) => {
  spo02Topao2Values[name] = value;
  const ImputedPaO2 = calculateImputedPaO2(spo02Topao2Values);
  const Pfratio = calculatePfratio(spo02Topao2Values);
  const Sfratio = calculateSfratio(spo02Topao2Values);

  emits('imputedPaO2', ImputedPaO2);
  emits('pfRatio', Pfratio);
  emits('sfRatio', Sfratio);
};
</script>

<style scoped>
img {
  width: 320px;
  filter: brightness(1.1);
  mix-blend-mode: multiply;
}
</style>
